import React from 'react';
import { Box, Skeleton } from '@mui/material';


const SimpleSkeletonLoader = ({  height = '15vw' }) => {
  return (
    <Box
      component="div"
      sx={{
        border: '1px solid lightgray',
        padding: '0.5vw',
        minHeight: height,
        backgroundColor: 'white'
      }}
    >
      {/* Header skeleton */}
      <Box component={'div'} mb={'1vw'}>
        <Skeleton 
          variant="rounded" 
          animation="wave" 
          width={'100%'} 
          height={'3vw'} 
          sx={{ mb: '0.5vw' }} 
        />
      </Box>
      
      {/* Content skeleton rows */}
        <Box component={'div'} mb={'0.5vw'}>
          <Skeleton 
            variant="rounded" 
            animation="wave" 
            width={'100%'} 
            height={'9.4vw'} 
            sx={{ mb: '0.3vw' }} 
          />
        </Box>
    </Box>
  );
};

export default SimpleSkeletonLoader;


